import React from 'react';
import cn from 'classnames';
import { Button } from "../../CTA";
import styles from '../Carousel.module.scss';
const CarouselText = ({ onClick, label, disabled = false, direction, }) => {
    return (React.createElement(Button, { className: cn(styles.text, styles[direction]), disabled: disabled, onClick: onClick, size: "small", secondary: true }, label));
};
export default CarouselText;
//# sourceMappingURL=CarouselText.js.map